import React from "react";
import barreauPhotoRecherche from "../assets/barreauPhotoRecherche.png";
import barreauPhotoCaseCocher from "../assets/barreauPhotoCaseCocher.png";
import resultatRecherchePhoto from "../assets/resultatRecherchePhoto.png";

function OrientationCabinets() {
  return (
    <div className="min-h-screen bg-gray-100">
      <main className="max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="px-6 py-8 mt-4 bg-blue-50 rounded-xl border border-blue-100 shadow-sm mb-8">
          <h1 className="text-2xl font-bold text-blue-700 mb-3 text-center">
            <span className="inline-block h-1 bg-warning w-8 mr-2 rounded-full align-middle"></span>
            Trouver un avocat acceptant l'aide juridique
            <span className="inline-block h-1 bg-warning w-8 ml-2 rounded-full align-middle"></span>
          </h1>
          <p className="text-center text-blue-600 max-w-3xl mx-auto">
            Guide pour trouver un avocat compétent et abordable, habitué aux dossiers d'aide juridique.
          </p>
        </div>

        {/* Main content */}
        <div className="space-y-6">
          {/* Section 1: Pourquoi */}
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
            <h2 className="text-xl font-semibold text-blue-700 mb-4 flex items-center">
              <span className="bg-blue-50 p-2 rounded-full mr-2">💡</span>
              Pourquoi chercher un avocat acceptant l'aide juridique ?
            </h2>
            <div className="space-y-4">
              <p className="text-sm text-slate-600">
                Certains avocats au Québec choisissent de prendre des dossiers en aide juridique, 
                souvent <strong>moins payés</strong> que leurs mandats privés. Ils sont alors habitués à travailler 
                <strong> rapidement</strong> et <strong>efficacement</strong>, notamment pour les dossiers de divorce, séparation, 
                garde, etc.
              </p>
              <div className="bg-green-50 border-l-4 border-green-200 p-4 rounded-r-lg">
                <p className="text-sm text-green-700">
                  <strong>L'avantage :</strong> Ces avocats ont l'habitude des dossiers familiaux <strong>standardisés</strong>. 
                  Vous pouvez discuter librement avec eux de leurs tarifs et de votre budget, sans exploser vos coûts.
                </p>
              </div>
              <div className="bg-yellow-50 border-l-4 border-yellow-200 p-4 rounded-r-lg">
                <p className="text-sm text-yellow-700">
                  <strong>Important :</strong> Vous devez trouver une relation de confiance. Ne laissez pas l'avocat tout décider, 
                  mais respectez aussi son expertise.
                </p>
              </div>
            </div>
          </div>

          {/* Section 2: Recherche */}
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
            <h2 className="text-xl font-semibold text-blue-700 mb-4 flex items-center">
              <span className="bg-blue-50 p-2 rounded-full mr-2">🔍</span>
              Chercher dans le bottin du Barreau
            </h2>
            <div className="space-y-4">
              <p className="text-sm text-slate-600">
                Rendez-vous sur le site :
              </p>
              <a
                href="https://www.barreau.qc.ca/fr/trouver-un-avocat/"
                target="_blank"
                rel="noreferrer"
                className="block p-4 bg-blue-50 rounded-lg text-blue-700 hover:bg-blue-100 transition-colors"
              >
                www.barreau.qc.ca/fr/trouver-un-avocat/
              </a>
              <div className="bg-slate-50 p-4 rounded-lg">
                <h3 className="font-semibold text-slate-700 mb-2">Critères de recherche :</h3>
                <ul className="space-y-2 text-sm text-slate-600">
                  <li>• <strong>Domaine :</strong> "Droit familial"</li>
                  <li>• <strong>Région / ville :</strong> Votre localisation</li>
                  <li>• <strong>Option :</strong> "Accepte les mandats d'aide juridique"</li>
                  <li>• <strong>Langue :</strong> Vous pouvez choisir la langue de communication (français ou anglais)</li>
                </ul>
              </div>
              {/* Images - Improved presentation */}
              <div className="space-y-6 mt-2">
                <h3 className="font-semibold text-slate-700 text-center">Guide visuel de recherche</h3>
                
                {/* Image 1 - Page de recherche */}
                <div className="bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden">
                  <div className="p-3 bg-blue-50 border-b border-slate-200">
                    <h4 className="font-medium text-blue-700 text-sm">1. Page de recherche du Barreau</h4>
                  </div>
                  <div className="p-4">
                    <img 
                      src={barreauPhotoRecherche} 
                      alt="Page de recherche du Barreau" 
                      className="max-w-full h-auto mx-auto rounded-md"
                    />
                    <p className="text-xs text-slate-500 mt-2 italic text-center">
                      Utilisez les filtres pour préciser votre recherche
                    </p>
                  </div>
                </div>
                
                {/* Image 2 - Case à cocher */}
                <div className="bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden">
                  <div className="p-3 bg-blue-50 border-b border-slate-200">
                    <h4 className="font-medium text-blue-700 text-sm">2. Cochez "Accepte les mandats d'aide juridique"</h4>
                  </div>
                  <div className="p-4">
                    <img 
                      src={barreauPhotoCaseCocher} 
                      alt="Case à cocher pour l'aide juridique" 
                      className="max-w-full h-auto mx-auto rounded-md"
                    />
                    <p className="text-xs text-slate-500 mt-2 italic text-center">
                      Cette option filtre les avocats qui acceptent les mandats d'aide juridique
                    </p>
                  </div>
                </div>
                
                {/* Image 3 - Résultats */}
                <div className="bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden">
                  <div className="p-3 bg-blue-50 border-b border-slate-200">
                    <h4 className="font-medium text-blue-700 text-sm">3. Consultez les résultats</h4>
                  </div>
                  <div className="p-4">
                    <img 
                      src={resultatRecherchePhoto} 
                      alt="Résultats de recherche d'avocats" 
                      className="max-w-full h-auto mx-auto rounded-md"
                    />
                    <p className="text-xs text-slate-500 mt-2 italic text-center">
                      Vous obtiendrez une liste d'avocats correspondant à vos critères
                    </p>
                  </div>
                </div>
                
                <div className="bg-blue-50 border-l-4 border-blue-200 p-4 rounded-r-lg">
                  <p className="text-sm text-blue-700">
                    <strong>Astuce :</strong> Vous pouvez basculer entre français et anglais en utilisant le bouton de langue 
                    en haut à droite du site du Barreau.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Section 3: Contact */}
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
            <h2 className="text-xl font-semibold text-blue-700 mb-4 flex items-center">
              <span className="bg-blue-50 p-2 rounded-full mr-2">📞</span>
              Comment aborder l'avocat
            </h2>
            <div className="space-y-4">
              <p className="text-sm text-slate-600">
                Une fois la liste en main, contactez quelques avocats pour comparer :
              </p>
              <div className="bg-blue-50 rounded-lg p-4">
                <h3 className="font-semibold text-blue-700 mb-2">Points à aborder :</h3>
                <ul className="space-y-2 text-sm text-blue-600">
                  <li>1. Présentez votre dossier brièvement</li>
                  <li>2. Mentionnez que vous avez vos documents prêts</li>
                  <li>3. Demandez les modalités de paiement et tarifs</li>
                </ul>
              </div>
              <div className="bg-slate-50 border-l-4 border-slate-200 p-4 rounded-r-lg">
                <p className="text-sm text-slate-600">
                  <strong>Note :</strong> L'avocat a le droit de refuser un mandat privé. Mais s'il est habitué 
                  aux dossiers d'aide juridique, il est souvent efficace et conscient des contraintes budgétaires.
                </p>
              </div>
            </div>
          </div>

          {/* Section 4: Relation */}
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
            <h2 className="text-xl font-semibold text-blue-700 mb-4 flex items-center">
              <span className="bg-blue-50 p-2 rounded-full mr-2">🤝</span>
              Établir une bonne relation
            </h2>
            <div className="space-y-4">
              <div className="grid gap-4 md:grid-cols-2">
                <div className="bg-green-50 rounded-lg p-4 border border-green-200">
                  <h3 className="font-semibold text-green-700 mb-2">À faire</h3>
                  <ul className="space-y-2 text-sm text-green-600">
                    <li>• Préparer vos questions à l'avance</li>
                    <li>• Être concis et réaliste</li>
                    <li>• Respecter l'expertise de l'avocat</li>
                  </ul>
                </div>
                <div className="bg-red-50 rounded-lg p-4 border border-red-200">
                  <h3 className="font-semibold text-red-700 mb-2">À éviter</h3>
                  <ul className="space-y-2 text-sm text-red-600">
                    <li>• Être trop méfiant</li>
                    <li>• Avoir des exigences irréalistes</li>
                    <li>• Être désorganisé</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Résumé */}
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
            <h2 className="text-xl font-semibold text-blue-700 mb-4 flex items-center">
              <span className="bg-blue-50 p-2 rounded-full mr-2">✨</span>
              En résumé
            </h2>
            <div className="space-y-4">
              <ol className="list-decimal list-inside text-sm text-slate-600 space-y-2">
                <li>Cherchez sur le site du Barreau avec les bons filtres</li>
                <li>Contactez plusieurs avocats pour comparer</li>
                <li>Choisissez celui qui correspond à vos besoins et budget</li>
              </ol>
              <div className="bg-blue-50 border-l-4 border-blue-200 p-4 rounded-r-lg mt-4">
                <p className="text-sm text-blue-700">
                  Cette approche permet souvent de trouver un avocat <strong>moins cher</strong> que certains cabinets 
                  très publicisés, tout en bénéficiant d'une expérience solide en droit familial.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Legal note */}
        <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 text-sm text-slate-600 mt-8">
          <p className="italic text-center">
            Note : Ces informations sont fournies à titre indicatif. Les honoraires et disponibilités des avocats 
            peuvent varier. N'hésitez pas à comparer plusieurs options.
          </p>
        </div>
      </main>
    </div>
  );
}

export default OrientationCabinets;
